// libs
import axios from 'axios'
import qs from 'qs'

// api
import { refreshToken } from './auth/refreshToken'

// utils
import { language } from '../util/language'

// env
const url = process.env.VUE_APP_API_URL
const clientId = process.env.VUE_APP_CLIENT_ID
const clientSecret = process.env.VUE_APP_CLIENT_SECRET

// api
const axiosInstance = axios.create({
  baseURL: url,
  paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
})

// interceptors
axiosInstance.interceptors.request.use(
  (request) => {
    if (localStorage.getItem('access_token')) {
      request.headers = {
        'Content-Type': 'application/json',
        'Accept-Language': language(),
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
      }
    } else {
      request.headers = {
        'Content-Type': 'application/json',
        'Accept-Language': language(),
      }
    }

    request.timeout = 60000

    return request
  },
  async ({ response }) => {
    return Promise.reject(response)
  }
)

// interceptors
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (axios.isCancel(error)) {
      return Promise.reject(error)
    }

    if (error.message === 'Network Error') {
      return Promise.reject(error.message)
    }

    if (!error.response) {
      return Promise.reject(error)
    }

    const { data } = error.response
    const originalRequest = error.config

    if (data.error === 'invalid_token') {
      return refreshToken(url).then(() => {
        return axios.request(originalRequest)
      })
    }

    if (data.status === 401) {
      return axios.request(error.config)
    }

    return Promise.reject(error.response)
  }
)

// methods
export const api = {
  get(endpoint, params) {
    return axiosInstance.get(endpoint, params)
  },

  post(endpoint, payload, config = {}) {
    return axiosInstance.post(endpoint, payload, config)
  },

  put(endpoint, payload) {
    return axiosInstance.put(endpoint, payload)
  },

  delete(endpoint) {
    return axiosInstance.delete(endpoint)
  },

  login({ username, password }) {
    localStorage.clear()

    const params = new URLSearchParams()
    params.append('username', username)
    params.append('password', password)
    params.append('grant_type', 'password')

    const loginToken = window.btoa(clientId + ':' + clientSecret)

    const headers = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Accept-Language': language(),
        Authorization: `Basic ${loginToken}`,
      },
    }

    return axios.post(`${url}/oauth/token`, params, headers)
  },
}
